"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StatusRectangle = _styledComponents.default.div.withConfig({
  displayName: "StatusRectangle"
})(["min-width:14px;min-height:3px;width:1vw;height:0.35vh;background-color:", ";margin-right:0.5rem;"], function (_ref) {
  var color = _ref.color;
  return color ? color : null;
});

StatusRectangle.displayName = 'StatusRectangle';

var StatusesContainer = _styledComponents.default.div.withConfig({
  displayName: "StatusesContainer"
})(["display:flex;"]);

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container"
})(["font-family:", ";span{font-size:1.2rem;margin-bottom:0.53rem;line-height:120%;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});
/**
 * Returns valid HEX color depending on
 * current item index
 * @param {number} mappedIndex
 * @param {number} currentIndex
 */


var getRectangleColor = function getRectangleColor(mappedIndex) {
  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  if (mappedIndex < currentIndex) return '#37D66C';else if (mappedIndex === currentIndex) return '#FFD600';else return '#F1EFEF';
};

var OverviewClaimStatus = function OverviewClaimStatus(_ref3) {
  var statuses = _ref3.statuses,
      currentStatus = _ref3.currentStatus,
      className = _ref3.className,
      rest = _objectWithoutProperties(_ref3, ["statuses", "currentStatus", "className"]);

  var rectangles = statuses.map(function (status, i) {
    return /*#__PURE__*/_react.default.createElement(StatusRectangle, {
      key: status,
      color: getRectangleColor(i, statuses.indexOf(currentStatus))
    });
  });
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    className: className
  }, rest), /*#__PURE__*/_react.default.createElement("span", null, currentStatus), /*#__PURE__*/_react.default.createElement(StatusesContainer, null, rectangles));
};

OverviewClaimStatus.propTypes = {
  statuses: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  currentStatus: _propTypes.default.string,
  className: _propTypes.default.string
};
OverviewClaimStatus.defaultProps = {
  statuses: []
};
var _default = OverviewClaimStatus;
exports.default = _default;